import { IconProps } from "../icons.types";

const defaultColor = "var(--gravx-color-neutral-on-light-grey-7)";
const defaultSuccessColor = "var(--gravx-color-utility-success-on-light-background)";
const xmlnsUrl = "http://www.w3.org/2000/svg";

/** @deprecated - use an export from figma with 24x24 px dimensions */
export const CheckmarkIcon = ({
  fillPath = defaultColor,
  fillSvg = "none",
  height = "13",
  title = "",
  viewBox = "0 0 18 13",
  width = "18",
}: IconProps) => {
  return (
    <svg fill={fillSvg} height={height} viewBox={viewBox} width={width} xmlns={xmlnsUrl}>
      {Boolean(title) && <title>{title}</title>}
      <path
        d="M5.99965 10.1698L2.52965 6.69982C2.13965 6.30982 1.50965 6.30982 1.11965 6.69982C0.729648 7.08982 0.729648 7.71982 1.11965 8.10982L5.29965 12.2898C5.68965 12.6798 6.31965 12.6798 6.70965 12.2898L17.2896 1.70982C17.6796 1.31982 17.6796 0.689824 17.2896 0.299824C16.8997 -0.0901758 16.2696 -0.0901758 15.8796 0.299824L5.99965 10.1698Z"
        fill={fillPath}
      />
    </svg>
  );
};

export const CheckmarkCircledIcon = ({
  fillPath = defaultSuccessColor,
  fillSvg = "none",
  height = "20",
  title = "",
  viewBox = "0 0 20 20",
  width = "20",
}: IconProps) => {
  return (
    <svg fill={fillSvg} height={height} viewBox={viewBox} width={width} xmlns={xmlnsUrl}>
      {Boolean(title) && <title>{title}</title>}
      <path
        d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM7.29 14.29L3.7 10.7C3.31 10.31 3.31 9.68 3.7 9.29C4.09 8.9 4.72 8.9 5.11 9.29L8 12.17L14.88 5.29C15.27 4.9 15.9 4.9 16.29 5.29C16.68 5.68 16.68 6.31 16.29 6.7L8.7 14.29C8.32 14.68 7.68 14.68 7.29 14.29Z"
        fill={fillPath}
      />
    </svg>
  );
};

export const CheckmarkDottedCircledOutlineIcon = ({
  fillPath = defaultColor,
  fillSvg = "none",
  height = "20",
  title = "",
  viewBox = "0 0 20 20",
  width = "20",
}: IconProps) => {
  return (
    <svg fill={fillSvg} height={height} viewBox={viewBox} width={width} xmlns={xmlnsUrl}>
      {Boolean(title) && <title>{title}</title>}
      <path
        clipRule="evenodd"
        d="M17.9619 10.7868L19.9525 10.9805C19.9839 10.6579 20 10.3308 20 10C20 9.66915 19.9839 9.34206 19.9525 9.01945L17.9619 9.21318C17.9871 9.4715 18 9.73394 18 10C18 10.2661 17.9871 10.5285 17.9619 10.7868ZM17.6578 7.67608L19.5719 7.09617C19.3803 6.46374 19.1277 5.8578 18.821 5.28519L17.058 6.22951C17.3031 6.68725 17.5048 7.17124 17.6578 7.67608ZM16.1851 4.92562L17.7304 3.65597C17.3146 3.1499 16.8501 2.68539 16.344 2.2696L15.0744 3.81491C15.4798 4.14801 15.852 4.5202 16.1851 4.92562ZM13.7705 2.94204L14.7148 1.17901C14.1422 0.872313 13.5363 0.619741 12.9038 0.428132L12.3239 2.34221C12.8288 2.49516 13.3127 2.69686 13.7705 2.94204ZM10.7868 2.03806L10.9805 0.0474632C10.6579 0.016067 10.3308 0 10 0C9.66915 0 9.34206 0.016067 9.01945 0.0474633L9.21318 2.03806C9.4715 2.01292 9.73394 2 10 2C10.2661 2 10.5285 2.01292 10.7868 2.03806ZM7.67608 2.34221L7.09617 0.428132C6.46374 0.619742 5.8578 0.872314 5.28519 1.17901L6.22951 2.94204C6.68725 2.69686 7.17124 2.49517 7.67608 2.34221ZM4.92562 3.81491L3.65597 2.2696C3.1499 2.68539 2.68539 3.14991 2.2696 3.65597L3.81491 4.92562C4.14801 4.5202 4.5202 4.14801 4.92562 3.81491ZM2.94204 6.22951L1.17901 5.28519C0.872313 5.8578 0.619741 6.46374 0.428132 7.09617L2.34221 7.67608C2.49516 7.17124 2.69686 6.68726 2.94204 6.22951ZM0 10C0 9.66915 0.016067 9.34206 0.0474632 9.01945L2.03806 9.21318C2.01292 9.4715 2 9.73394 2 10C2 10.2661 2.01292 10.5285 2.03806 10.7868L0.0474633 10.9805C0.016067 10.6579 0 10.3308 0 10ZM2.34221 12.3239L0.428132 12.9038C0.619742 13.5363 0.872314 14.1422 1.17901 14.7148L2.94204 13.7705C2.69686 13.3127 2.49517 12.8288 2.34221 12.3239ZM3.81491 15.0744L2.2696 16.344C2.68539 16.8501 3.14991 17.3146 3.65597 17.7304L4.92562 16.1851C4.5202 15.852 4.14801 15.4798 3.81491 15.0744ZM6.22951 17.058L5.28519 18.821C5.8578 19.1277 6.46374 19.3803 7.09617 19.5719L7.67608 17.6578C7.17124 17.5048 6.68726 17.3031 6.22951 17.058ZM9.21318 17.9619L9.01945 19.9525C9.34206 19.9839 9.66915 20 10 20C10.3308 20 10.6579 19.9839 10.9806 19.9525L10.7868 17.9619C10.5285 17.9871 10.2661 18 10 18C9.73394 18 9.4715 17.9871 9.21318 17.9619ZM12.3239 17.6578L12.9038 19.5719C13.5363 19.3803 14.1422 19.1277 14.7148 18.821L13.7705 17.058C13.3127 17.3031 12.8288 17.5048 12.3239 17.6578ZM15.0744 16.1851L16.344 17.7304C16.8501 17.3146 17.3146 16.8501 17.7304 16.344L16.1851 15.0744C15.852 15.4798 15.4798 15.852 15.0744 16.1851ZM17.058 13.7705L18.821 14.7148C19.1277 14.1422 19.3803 13.5363 19.5719 12.9038L17.6578 12.3239C17.5048 12.8288 17.3031 13.3127 17.058 13.7705ZM7.38002 14.01L5.00002 11.61C4.61002 11.22 4.61002 10.59 5.00002 10.2L5.07002 10.13C5.46002 9.73999 6.10002 9.73999 6.49002 10.13L8.10002 11.75L13.25 6.58999C13.64 6.19999 14.28 6.19999 14.67 6.58999L14.74 6.65999C15.13 7.04998 15.13 7.67999 14.74 8.06998L8.82002 14.01C8.41002 14.4 7.78002 14.4 7.38002 14.01Z"
        fill={fillPath}
        fillRule="evenodd"
      />
    </svg>
  );
};

export const CheckmarkSmallIcon = ({ fillPath = defaultColor }: IconProps) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.6846 7.33069C18.1051 7.7716 18.1051 8.48646 17.6846 8.92738L10.3 16.6693C9.8794 17.1102 9.19753 17.1102 8.77696 16.6693L6.31542 14.0887C5.89486 13.6478 5.89486 12.9329 6.31542 12.492C6.73599 12.0511 7.41786 12.0511 7.83842 12.492L9.53846 14.2743L16.1616 7.33069C16.5821 6.88977 17.264 6.88977 17.6846 7.33069Z"
        fill={fillPath}
      />
    </svg>
  );
};

export const CheckmarkIconV2 = ({ fillPath = defaultColor }: IconProps) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.00012 16.1998L5.50012 12.6998C5.11012 12.3098 4.49012 12.3098 4.10012 12.6998C3.71012 13.0898 3.71012 13.7098 4.10012 14.0998L8.29012 18.2898C8.68012 18.6798 9.31012 18.6798 9.70012 18.2898L20.3001 7.69982C20.6901 7.30982 20.6901 6.68982 20.3001 6.29982C19.9101 5.90982 19.2901 5.90982 18.9001 6.29982L9.00012 16.1998Z"
        fill={fillPath}
      />
    </svg>
  );
};
